/**
 * Turn a tRPC mutation error into something a visitor should read.
 *
 * A server-sent tRPC error carries a `data` payload (its code and HTTP
 * status), and its `message` is copy we wrote for that case - show it. A
 * transport failure (the Worker is unreachable, a gateway returned HTML, the
 * body was not JSON) has no `data`, and its raw message - e.g. "Failed to
 * execute 'json' on 'Response'" - means nothing to a visitor, so fall back to
 * the calm, situation-specific line the caller supplies.
 */
export function requestErrorMessage(
  err: { message: string; data?: unknown },
  fallback: string,
): string {
  return err.data == null ? fallback : err.message;
}
